<template>
    <div class="modalShadow" :class="{visible}" :id="id+'Shadow'">
        <dialog
            :id="id"
            v-if="visible"
            style="visibility: visible; display: flex; max-height: 95vh;"
            :style="specialStyles"
        >
            <div class="modal-dialog-content">
                <a href="#close" style="top:0" :v-if="!hideClose" @click.prevent.stop="hide"></a>
                <div :id="id+'Body'" class="modal-dialog-body" :class="{body_overflow: overflow}">
                    <slot></slot>
                </div>
                <footer>
                    <slot name="footer"></slot>
                </footer>
            </div>
        </dialog>
    </div>
</template>

<script>
export default {
    name: "DoctuDialog",

    props: {
        id: {
            default: 'vdialog'
        },
        overflow: {
            default: false
        },
        hideClose: {
            default: false
        },
        specialStyles: {
            type: Object, default: () => {}
        },
        onCloseEsc: {
            type: Function, default: null,
        }
    },

    data() {
        return {
            visible: false,
        }
    },
    computed: {
        keyName: function () {
            return location.pathname + '@vuedialog#' + this.id;
        },
    },

    methods: {
        onKeyPress (event) {
            if (event.key && event.key === 'Enter') {
                if (event.target.className !== 'multiselect__input' && event.target.nodeName !== 'TEXTAREA')
                    event.preventDefault();
            }
        },

        show() {
            let promise = new Promise((resolve, reject) => {
                this.$nextTick().then(() => {
                    this.visible = true;
                    this.$emit('shown');
                    resolve(this);
                });
            })
            window.addEventListener("keydown", this.onKeyPress);
            return promise;
        },
        hide() {
            let promise = new Promise((resolve, reject) => {
                this.visible = false;
                this.$emit('hidden');
                resolve(this);
            })
            window.removeEventListener("keydown", this.onKeyPress);
            return promise;
        },
        toggle() {
            if (this.visible) {
                return this.hide();
            } else {
                return this.show();
            }
        },
    },

    mounted() {
        this.$bus.listen('esc', (dialogId) => {
            if (this.$el && this.$el.id === dialogId) {
                if (this.onCloseEsc) {
                    this.onCloseEsc();
                } else {
                    this.hide();
                }
            }
        })
    },

    watch: {
        visible() {
            if (this.visible) {
                this.$store.commit('hideComponent/add', this)
            } else {
                this.$store.commit('hideComponent/remove')
            }
        }
    },
}
</script>

<style lang="scss">
.body_overflow {
    overflow: visible !important;
}
.modalShadow {
    z-index: 10000;

    dialog .modal-dialog-content {
        display: flex;
        flex-direction: column;
        height: auto;
        width: 100%;
    }

    dialog .modal-dialog-content .modal-dialog-body {
        overflow-x: auto;
    }

    &_without-overflow {
        & dialog {
            overflow: unset !important;
        }

        & .modal-dialog-body {
            overflow: unset !important;
        }
    }
}

table.grid > tr > td {
    border: 5px solid transparent;
}
</style>
